import { useState } from "react";

export default () => {
  var [file, setfile] = useState<any>();
  var [files, setFiles]=useState([""])


  const refreshfile = () => {
    setfile("");
  };

  const callback =(file:any)=>{
setFiles((prev)=>prev.concat(file))

  }

  return { files, setFiles,callback, file, setfile, refreshfile };
};
